var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 5 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m0 1.195 3.348 3.048a1.67 1.67 0 0 1 0 2.515L.001 9.805l.764.695 3.347-3.046c1.184-1.077 1.184-2.83 0-3.907L.764.5 0 1.195Z",
  fill: "currentColor"
})));
export default SvgChevronRight;